import styled from 'styled-components';

export const IconWrapper = styled.div`
  position: relative;
  display: flex;
  height: 38px;
  align-items: center;
  right: 5px;
  cursor: ${({ disabled }) => (disabled ? 'cursor' : 'pointer')};
`;
